import { ResourceApi } from 'services/api'
import { HelpItem } from 'model/help'
class HelpApi extends ResourceApi<HelpItem> {}

export default new HelpApi('/api/ayuda')
